// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__1MRsw","title":"Chart_title__3aJAY","duration":"Chart_duration__3yIdQ","more":"Chart_more__1o9td"};